/**
 * 全局路由配置文件
 */

import Vue from 'vue';
import Router from 'vue-router';
import Entry from '../views/Home/Entry.vue';
import Result from '../views/Home/Result.vue';
import RecruitActivity from '../views/Recruit/Activity.vue';
import RecruitActivityNew from '../views/RecruitNew/Activity.vue';
import PublicLink from '../views/Public/index.vue';
import Code from '../views/Public/code.vue';
import chineseDictation from '../views/applyForm/chineseDictation/index.vue';
import chineseDictationDetail from '../views/applyForm/chineseDictation/detail.vue';
import oldChangeNew from '../views/applyForm/oldChangeNew/index.vue';
import oldChangeNewDetail from '../views/applyForm/oldChangeNew/detail.vue';
import commonForm from '../views/applyForm/commonForm/index.vue';
import commonFormDetail from '../views/applyForm/commonForm/detail.vue';
import miniprogramEntry from '../views/miniprogramEntry/index.vue';
import publicBanner from '../views/PublicBanner/index.vue'
import unitList from '../views/unitList/index.vue'
import videoPlayer from '../views/videoPlayer/index.vue'

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'entry',
            component: Entry,
            meta: {
                title: '智慧导购',
            },
        },
        {
            path: '/clue-input/',
            name: 'clue-input',
            component: Entry,
            meta: {
                title: '活动报名',
            },
        },
        {
            path: '/result',
            name: 'result',
            component: Result,
            meta: {
                title: '智慧导购',
            },
        },
        {
            path: '/recruit-activity',
            name: 'recruit-activity',
            component: RecruitActivity,
            meta: {
                title: '招募活动',
            },
        },
        {
            path: '/recruit-activity-new',
            name: 'recruit-activity-new',
            component: RecruitActivityNew,
            meta: {
                title: '招募活动',
            },
        },
        {
            path: '/public-link',
            name: 'public-link',
            component: PublicLink,
            meta: {
                title: '公益链接',
            },
        },
        {
            path: '/code',
            name: 'code',
            component: Code,
            meta: {
                title: '微信联系',
            },
        },
        {
            path: '/chineseDictation',
            name: 'chineseDictation',
            component: chineseDictation,
            meta: {
                title: '完善身份信息',
            },
        },
        {
            path: '/chineseDictationDetail',
            name: 'chineseDictation',
            component: chineseDictationDetail,
            meta: {
                title: '提交结果',
            },
        },
        {
            path: '/oldChangeNew',
            name: 'oldChangeNew',
            component: oldChangeNew,
            meta: {
                title: '优学派特惠购',
            },
        },
        {
            path: '/oldChangeNewDetail',
            name: 'oldChangeNewDetail',
            component: oldChangeNewDetail,
            meta: {
                title: '优学派特惠购',
            },
        },
        {
            path: '/commonForm',
            name: 'commonForm',
            component: commonForm,
        },
        {
            path: '/commonFormDetail',
            name: 'commonFormDetail',
            component: commonFormDetail,
        },
        {
            path: '/miniprogramEntry',
            name: 'miniprogramEntry',
            component: miniprogramEntry,
        },
        {
            path: '/publicBanner',
            name: 'publicBanner',
            component: publicBanner,
        },
        {
            path: '/unitList',
            name: 'unitList',
            component: unitList,
            meta: {
                title: '优学派名师带你学',
                keepAlive: true
            },
        },
        {
            path: '/videoPlayer',
            name: 'videoPlayer',
            component: videoPlayer,
            meta: {
                title: '优学派名师带你学',
            },
        },
    ]
})

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
});

export default router;
